// @flow

export const SET_PERMISSIONS: 'auth/action/permissions/set' =
  'auth/action/permissions/set';

export type Action = { type: typeof SET_PERMISSIONS, permissions: Array<any> };
